export default __webpack_public_path__ + "static/media/placeholder_dummy2016-tennisclub01-de.02beb7c0.png";